// Sample quarterly spend for the contact Overview "Spending trend" card, oldest first (last 2 years)

export interface QuarterSpend {
  quarter: string;
  spend: number;
  bottles: number;
}

export const contactQuarterlySpend: QuarterSpend[] = [{
  quarter: 'Q4 2024',
  spend: 260,
  bottles: 7
}, {
  quarter: 'Q1 2025',
  spend: 300,
  bottles: 8
}, {
  quarter: 'Q2 2025',
  spend: 240,
  bottles: 6
}, {
  quarter: 'Q3 2025',
  spend: 280,
  bottles: 7
}, {
  quarter: 'Q4 2025',
  spend: 310,
  bottles: 8
}, {
  quarter: 'Q1 2026',
  spend: 345,
  bottles: 9
}, {
  quarter: 'Q2 2026',
  spend: 290,
  bottles: 8
}, {
  quarter: 'Q3 2026',
  spend: 330,
  bottles: 9
}];

// Alternative history for previewing a contact who is buying less (about -22%)
export const contactQuarterlySpendDeclining: QuarterSpend[] = [{
  quarter: 'Q4 2024',
  spend: 340,
  bottles: 9
}, {
  quarter: 'Q1 2025',
  spend: 310,
  bottles: 8
}, {
  quarter: 'Q2 2025',
  spend: 330,
  bottles: 9
}, {
  quarter: 'Q3 2025',
  spend: 300,
  bottles: 8
}, {
  quarter: 'Q4 2025',
  spend: 280,
  bottles: 7
}, {
  quarter: 'Q1 2026',
  spend: 250,
  bottles: 7
}, {
  quarter: 'Q2 2026',
  spend: 240,
  bottles: 6
}, {
  quarter: 'Q3 2026',
  spend: 200,
  bottles: 5
}];

// A recent one-time order, added in the demo so Ordering Cadence reads "on track"
export const recentExtraPurchaseDemoOrder = {
  orderNumber: '#4588',
  date: '2026-09-26',
  channel: 'Online' as const,
  items: [{
    title: 'Barossa Shiraz',
    vintage: '2021',
    quantity: 3,
    price: 45
  }]
};
